// Global packages and components
import { clsx } from 'clsx'
import { ProductCard } from '~/components'

// Types
import type { ProductSearchItem } from '~/types'

interface Props {
  activeDisplay: 'grid' | 'list'
  products: ProductSearchItem[]
}

// Number of cards given fetchpriority, roughly the first visible row
const PRIORITY_CARDS = 3

// Index keys would let React reuse a card's DOM for a different product when
// the page changes, mutating the image src and the Trustpilot sku in place
const getProductKey = (product: ProductSearchItem, index: number) =>
  product.variantStockCode ?? product.url?.stockCode ?? `index-${index}`

// Main export
const ProductGrid = ({ activeDisplay, products }: Props) => {
  return products && products.length > 0 ? (
    <ul
      className={clsx('mb-6 grid', {
        'grid-cols-2 gap-3 md:grid-cols-3 lg:gap-5': activeDisplay === 'grid',
        'grid-cols-1': activeDisplay === 'list',
      })}
    >
      {products.map((e, i) => (
        <li
          key={getProductKey(e, i)}
          className="mb-3 lg:mb-5"
        >
          <ProductCard
            {...e}
            layout={activeDisplay}
            priority={i < PRIORITY_CARDS}
          />
        </li>
      ))}
    </ul>
  ) : (
    <p>No products found</p>
  )
}

export default ProductGrid
